import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function institutions(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_INSTITUTIONS_LIST":
			return update(state, { list: { $set: action.institutions } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/institutions/reducer.js